import { render, staticRenderFns } from "./CalendarBody.vue?vue&type=template&id=a76d15f4&lang=pug&"
import script from "./CalendarBody.vue?vue&type=script&lang=js&"
export * from "./CalendarBody.vue?vue&type=script&lang=js&"
import style0 from "./CalendarBody.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports